import React from 'react';
import {
  Modal,
  Box,
  Typography,
  Button,
  Stack,
  Divider,
} from '@mui/material';

interface UnauthorizedPopupProps {
  open: boolean;
}

const SessionTimeoutPopup= ({
}) => {
  const handleClose = () => {
    window.location.href = "/auth/logout"
  };



  return (
    <Modal
      open={true}
      onClose={handleClose}
      aria-labelledby="unauthorized-modal-title"
      aria-describedby="unauthorized-modal-description"
    >
     
      <Box
        sx={{
          position: 'absolute' as const,
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 'calc(100% - 32px)',
          maxWidth: 420,
          outline: "none",
            bgcolor: 'background.paper',
          border: "1px solid red",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Stack spacing={2}>
      

          <Typography id="unauthorized-modal-description" sx={{ mb: 1 }}>
          Session expired, please log in.
          </Typography>

          <Stack direction="row" justifyContent="flex-end" spacing={1}>
         
            <Button
              variant="contained"
              color="error"
              onClick={handleClose}
            >
              Go to Login
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};

export default SessionTimeoutPopup;
